import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { CheckSquare, ArrowUpRight } from "lucide-react";
import api from "@/lib/api";
import { Loader } from "@/components/common/Loader";
import { PageHeader, StatusBadge, EmptyState } from "@/components/dashboard/ui";

export default function Selections() {
  const [events, setEvents] = useState(null);
  useEffect(() => { api.get("/events").then((r) => setEvents(r.data.events)).catch(() => setEvents([])); }, []);
  if (!events) return <Loader />;

  return (
    <div>
      <PageHeader title="Selections" subtitle="Track album selection progress across every event." />
      {events.length === 0 ? <EmptyState icon={CheckSquare} title="No selections yet" desc="Selections appear once clients start choosing photos." /> : (
        <div className="space-y-3">
          {events.map((e) => {
            const pct = e.photo_count ? Math.round((e.selected_count / e.photo_count) * 100) : 0;
            return (
              <Link key={e.id} to={`/app/events/${e.id}?tab=selections`} data-testid={`selection-row-${e.id}`}
                className="flex items-center gap-4 rounded-xl border border-border bg-black/40 p-4 hover:border-gold/30 transition-colors group">
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2"><span className="text-white font-medium">{e.name}</span><StatusBadge status={e.selection_status} /></div>
                  <div className="text-xs text-muted-foreground mt-1">{e.client_name} · {e.selected_count}/{e.photo_count} selected · {pct}%</div>
                  <div className="h-1.5 rounded-full bg-white/10 overflow-hidden mt-2 max-w-md"><div className="h-full bg-gold" style={{ width: `${pct}%` }} /></div>
                </div>
                <ArrowUpRight className="w-4 h-4 text-muted-foreground group-hover:text-gold" />
              </Link>
            );
          })}
        </div>
      )}
    </div>
  );
}
